import React from 'react';
import './App.css';
import BoxContainer from './BoxContainer';

function App() {
  return (
    <div className="App">
      <BoxContainer />
    </div>
  );
}

export default App;
